export default __webpack_public_path__ + "static/media/ust.712a785c.svg";